import actionsFactory, {
  Actions,
} from 'modules/host-payout-methods/actions/actionsFactory';
import { PayoutAccount } from 'modules/host-payout-methods/models/PayoutAccount';
import {
  PayoutMethod,
  STRIPE_CONNECT,
} from 'modules/host-payout-methods/models/PayoutMethods';
import reducer from 'modules/host-payout-methods/reducers/reducer';
import { createContext, useMemo, useReducer } from 'react';
import React from 'react';

type ViewName = 'METHOD' | 'DETAILS' | 'CONFIRM';

export type CurrentPayoutAccountState = PayoutAccount;
export type ViewState = {
  currentView: ViewName;
  previousViews: Array<ViewName>;
};
export type PayoutMethodState = {
  data: PayoutMethod[];
  loading?: boolean;
  error?: any;
};

export type PayoutMethodsPerCountryState = {
  data: { [key: string]: PayoutMethod[] };
  loading?: boolean;
  error?: any;
};

export type PayoutAccountState = {
  data: PayoutAccount[];
  loading?: boolean;
  error?: any;
};

export const INIT_STATE = {
  currentPayoutAccount: {
    billingCountry: undefined,
    details: undefined,
    type: undefined,
    fields: {},
  },
  view: {
    currentView: 'METHOD',
    previousViews: [],
  } as ViewState,
  payoutMethods: {
    data: [],
    loading: false,
    error: undefined,
  },
  payoutMethodsPerCountry: {
    data: {},
    loading: false,
    error: undefined,
  },
  payoutAccounts: {
    data: [],
    loading: false,
    error: undefined,
  },
};

export type State = {
  currentPayoutAccount: CurrentPayoutAccountState;
  view: ViewState;
  payoutMethods: PayoutMethodState;
  payoutMethodsPerCountry: PayoutMethodsPerCountryState;
  payoutAccounts: PayoutAccountState;
};

const INIT_CONTEXT = {
  ...INIT_STATE,
  isEditable: true,
  actions: actionsFactory(() => {}),
};

type Context = {
  actions: Actions;
  isEditable: boolean;
} & State;

export const PayoutFormContext = createContext<Context>(INIT_CONTEXT);

type PayoutFormContextProviderProps = {
  children: any;
};

const PayoutFormContextProvider = ({
  children,
}: PayoutFormContextProviderProps) => {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);
  const actions = useMemo(() => actionsFactory(dispatch), [dispatch]);

  const isEditable =
    state.currentPayoutAccount?.details?.type !== STRIPE_CONNECT ||
    (state.currentPayoutAccount?.details?.type === STRIPE_CONNECT &&
      state.currentPayoutAccount?.details?.canAcceptPayouts === false);

  const contextValue = {
    ...state,
    isEditable,
    actions,
  };

  return (
    <PayoutFormContext.Provider value={contextValue}>
      {children}
    </PayoutFormContext.Provider>
  );
};

export default PayoutFormContextProvider;
